import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { RouterModule } from '@angular/router';
import { INPIHomeComponent } from './inpi-home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { INPIService } from './inpi.service';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [
    INPIHomeComponent,
  ],
  providers: [
    INPIService,
  ],
})
export class INPIModule { }
